/**------------- Section Background constants -------------**/

/*  General  */
export const SECTION_BACKGROUND_TEST_ID =
	"background-container";
